export function ConnectionStatus({ status }: { status: "connecting" | "online" | "offline" }) {
  const labels = { connecting: "Verbindet", online: "Live", offline: "Offline" };
  return <span className={`connection connection--${status}`}>{labels[status]}</span>;
}

export function ErrorBanner({ message, onClose }: { message?: string; onClose?: () => void }) {
  if (!message) return null;
  return (
    <div className="error-banner" role="alert">
      <span>{message}</span>
      {onClose ? (
        <button className="button button--ghost button--small" onClick={onClose}>
          Schließen
        </button>
      ) : null}
    </div>
  );
}

